import React, { useState } from 'react';
import ActionSheet from 'react-actionsheet';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Camera from 'components/Camera';
import Button from 'components/Button';
import './fileUpload.scss';
const documentRef = typeof document !== `undefined` ? document : null;

const FileUpload = ({ setValue, browseFile }) => {
  const [photoModal, setPhotoModal] = useState(false);
  const [photoName, setPhotoName] = useState('');
  const togglePhotoModal = () => setPhotoModal(!photoModal);

  const [show, setShow] = useState(false);
  const menus = [{ content: 'Take Photo' }, { content: 'Photo Library' }];

  const formElement = documentRef && documentRef.getElementById('formId');

  const setName = image => {
    setPhotoName(image ? image.name : null);
  };
  const onClick = e => {
    setShow(!show);
    if (formElement) {
      documentRef.body.classList.remove('overflow-hidden');
      formElement.classList.remove('modal-position');
    }
    if (e.target.innerHTML !== '' && e.target.innerHTML !== 'Cancel') {
      if (e.target.innerHTML === 'Take Photo') {
        togglePhotoModal();
      } else {
        _.isFunction(browseFile) && browseFile();
      }
    }
  };
  return (
    <div className="takePhoto-modal">
      <Button
        type="app-primary-button file-upload-btn"
        handleClick={() => {
          if (formElement) {
            documentRef.body.classList.add('overflow-hidden');
            formElement.classList.add('modal-position');
          }
          setShow(true);
        }}
      >
        Choose File
      </Button>
      <ActionSheet
        show={show}
        menus={menus}
        cancelText="Cancel"
        onRequestClose={index => {
          onClick(index);
        }}
      />

      <Camera
        isOpen={photoModal}
        toggle={togglePhotoModal}
        capture={image => {
          togglePhotoModal();
          setName(image);
          _.isFunction(setValue) && setValue(image);
        }}
        photoName={photoName}
      />
    </div>
  );
};

FileUpload.propTypes = {
  setValue: PropTypes.func,
};

export default FileUpload;
